/*
 * @Author: OnismYY 2848335733@qq.com
 * @LastEditTime: 2024-03-25 15:25:33
 * @FilePath: \js-yigrow-system\src\models\quick-icons-api.js
 * @Description: /quick-icons  快捷应用
 */
import { Base } from './base'

class QuickService extends Base {

  // 查询快捷方式
   getShortcut(params) {
    return  this.get('/all', { params })
  }

  // 修改快捷方式
   updateShortcut(data) {
    return  this.put('/', data)
  }
}

export default new QuickService({ prefix: '/v1/quick-icons' })